export default "__VITE_ASSET__0f4Ouo63__"